export const isAuth = (): boolean => {
  const tokenFromStorage = getToken();
  if (tokenFromStorage) {
    return true;
  }
  return false;
};

export const getToken = (): string | null => {
  return localStorage.getItem("token");
};

export const setToken = (token: string): void => {
  return localStorage.setItem("token", token);
};

export const deleteToken = (): void => {
  localStorage.removeItem("token");
};
